const genStatusStyle = token => {
  const {
    componentCls,
    menuCls,
    colorError,
    colorTextLightSolid
  } = token;
  const itemCls = "".concat(menuCls, "-item");
  return {
    ["".concat(componentCls, ", ").concat(componentCls, "-menu-submenu")]: {
      ["".concat(menuCls, " ").concat(itemCls)]: {
        ["&".concat(itemCls, "-danger:not(").concat(itemCls, "-disabled)")]: {
          color: colorError,
          '&:hover': {
            color: colorTextLightSolid,
            backgroundColor: colorError
          }
        }
      }
    }
  };
};
export default genStatusStyle;